import React, { useState } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { Button } from './ui/Button';
export function PortfolioSection() {
  const {
    t
  } = useLanguage();
  const [activeCategory, setActiveCategory] = useState(t('portfolio.all'));
  const [showAll, setShowAll] = useState(false);
  const categories = [t('portfolio.all'), t('portfolio.tailoring'), t('portfolio.fitting'), t('portfolio.restoration')];
  const displayedItems = showAll ? 9 : 3;
  return <section id="portfolio" className="py-28 lg:py-36 px-6 bg-[#FAFAF8]" data-id="element-188">
      <div className="max-w-[1600px] mx-auto" data-id="element-189">
        {/* Header */}
        <div className="flex flex-col lg:flex-row justify-between items-start lg:items-end mb-16 lg:mb-20" data-id="element-190">
          <div data-id="element-191">
            <span className="text-[10px] tracking-[0.4em] text-[#D4AF37] block mb-6 uppercase font-light" data-id="element-192">
              {t('portfolio.label')}
            </span>
            <h2 className="font-serif text-5xl lg:text-6xl font-light" data-id="element-193">
              {t('portfolio.title')}
            </h2>
          </div>

          {/* Filter Tabs */}
          <div className="flex gap-8 mt-10 lg:mt-0 border-b border-[#1A1A1A]/10" data-id="element-194">
            {categories.map(category => <button key={category} onClick={() => setActiveCategory(category)} className={`pb-4 text-[11px] tracking-[0.3em] uppercase transition-colors font-light relative ${activeCategory === category ? 'text-[#1A1A1A]' : 'text-gray-400 hover:text-[#1A1A1A]'}`} data-id="element-195">
                {category}
                {activeCategory === category && <div className="absolute bottom-0 left-0 right-0 h-[2px] bg-[#D4AF37]" data-id="element-196"></div>}
              </button>)}
          </div>
        </div>

        {/* Gallery Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8 mb-12" data-id="element-197">
          {[...Array(displayedItems)].map((_, item) => <div key={item} className="group relative aspect-[3/4] overflow-hidden cursor-pointer" data-id="element-198">
              <div className="absolute inset-0 bg-[#E5E0D8] transition-transform duration-1000 group-hover:scale-110" data-id="element-199">
                <div className="absolute inset-0 flex items-center justify-center" data-id="element-200">
                  <span className="font-serif italic text-lg text-gray-400 opacity-40" data-id="element-201">
                    {item === 0 ? 'Vintage Restoration' : `Work ${item + 1}`}
                  </span>
                </div>
              </div>

              {/* Overlay */}
              <div className="absolute inset-0 bg-black/0 group-hover:bg-black/30 transition-colors duration-500 flex items-center justify-center" data-id="element-202">
                <div className="opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-203">
                  <div className="w-12 h-12 border border-white flex items-center justify-center" data-id="element-204">
                    <span className="text-white text-2xl" data-id="element-205">+</span>
                  </div>
                </div>
              </div>
            </div>)}
        </div>

        {/* View All Button */}
        {!showAll && <div className="text-center" data-id="element-206">
            <Button variant="outline" onClick={() => setShowAll(true)} data-id="element-207">
              {t('portfolio.viewAll')}
            </Button>
          </div>}
      </div>
    </section>;
}